import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from "@angular/core";
import { SessionService } from "../services/session.service";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Directive({ selector: "[rlIsRlAdmin]" })
export class IsRlAdminDirective implements OnInit, OnDestroy {
	private readonly _templateRef = inject<TemplateRef<unknown>>(TemplateRef);
	private readonly _viewContainer = inject(ViewContainerRef);
	private readonly _sessionService = inject(SessionService);


	private readonly _subscriptions: Subscription[] = [];

	ngOnInit(): void {
		const sub = this._sessionService.isRlAdmin$.pipe(
			distinctUntilChanged()
		).subscribe(isRlAdmin => {
			if (isRlAdmin) {
				this._viewContainer.createEmbeddedView(this._templateRef);
			} else {
				this._viewContainer.clear();
			}
		});
		this._subscriptions.push(sub);
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach(sub => sub.unsubscribe());
	}

}